import React from 'react'

import yahoo from '../../images/sponsors/yahoo.svg'
import dena from '../../images/sponsors/dena.svg'
import newrelic from '../../images/sponsors/newrelic.svg'
import mixi from '../../images/sponsors/mixi.svg'
import uzabase from '../../images/sponsors/uzabase.svg'
import eureka from '../../images/sponsors/eureka.svg'
import voyage from '../../images/sponsors/voyage.svg'
import oisix from '../../images/sponsors/oisix.svg'
import dely from '../../images/sponsors/dely.svg'
import mercari from '../../images/sponsors/mercari.svg'
import merpay from '../../images/sponsors/merpay.svg'
import bizreach from '../../images/sponsors/bizreach.svg'
import elastic from '../../images/sponsors/elastic.svg'
import crowdworks from '../../images/sponsors/crowdworks.svg'
import optim from '../../images/sponsors/optim.png'
import speee from '../../images/sponsors/speee.svg'
import stores from '../../images/sponsors/stores.svg'
import hatena from '../../images/sponsors/hatena.svg'
import nikkei from '../../images/sponsors/nikkei.svg'
import sumzap from '../../images/sponsors/sumzap.jpg'
import dip from '../../images/sponsors/dip.png'
import bengo4 from '../../images/sponsors/bengo4.svg'
import quipper from '../../images/sponsors/quipper.svg'
import hennge from '../../images/sponsors/hennge.svg'
import recruitlifestyle from '../../images/sponsors/recruit-lifestyle.svg'
import nulab from '../../images/sponsors/nulab.svg'
import sakurayoga from '../../images/sponsors/sakurayoga.png'

import netmarkjp from '../../images/sponsors/personal/netmarkjp.png'
import Kazu from '../../images/sponsors/personal/Kazu.jpg'
import k12u from '../../images/sponsors/personal/k12u.jpg'
import lunaphilia from '../../images/sponsors/personal/lunaphilia.jpg'
import naofumi0628 from '../../images/sponsors/personal/naofumi0628.jpg'
import ohr486 from '../../images/sponsors/personal/ohr486.png'
import hmatsu47 from '../../images/sponsors/personal/hmatsu47.jpg'
import tigerroll from '../../images/sponsors/personal/tigerroll.jpg'
import tyabe from '../../images/sponsors/personal/tyabe.png'
import tmknom from '../../images/sponsors/personal/tmknom.jpg'
import nntsugu from '../../images/sponsors/personal/nntsugu.jpg'
import nekoruri from '../../images/sponsors/personal/nekoruri.jpg'
import mass from '../../images/sponsors/personal/mass.jpg'
import yoshikaw from '../../images/sponsors/personal/yoshikaw.jpg'
import sky_joker from '../../images/sponsors/personal/sky_joker.jpg'
import dododo8m from '../../images/sponsors/personal/dododo8m.jpg'
import mtsuka from '../../images/sponsors/personal/mtsuka.jpg'

const Sponsor = () => (
  <section className="ts-intro-sponsors">
    <a id="sponsors" className="anchor" />
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <h2 className="section-title white">
            <span>Sponsors</span>
            スポンサー
          </h2>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="single-intro-text sponsors-logo text-center">
            <div className="platinum">
              <h3>
                <span>PLATINUM</span>
              </h3>
              <a href="https://www.yahoo.co.jp/" target="_blank">
                <img src={yahoo} alt="Yahoo! JAPAN" />
              </a>
              <a
                href="https://dena.com/jp/recruit/career/engineer/"
                target="_blank"
              >
                <img src={dena} alt="DeNA" />
              </a>
              <a href="https://newrelic.co.jp/" target="_blank">
                <img src={newrelic} alt="NewRelic" />
              </a>
              <a href="https://mixi.co.jp/recruit/" target="_blank">
                <img src={mixi} alt="mixi" />
              </a>
              <a href="https://www.uzabase.com" target="_blank">
                <img src={uzabase} alt="UZABASE" />
              </a>
              <a href="https://eure.jp" target="_blank">
                <img src={eureka} alt="eureka" />
              </a>
            </div>
            <div className="gold">
              <h3>
                <span>GOLD</span>
              </h3>
              <a href="https://focus.voyagegroup.com/" target="_blank">
                <img src={voyage} alt="VOYAGE GROUP" />
              </a>
              <a href="https://www.oisixradaichi.co.jp/" target="_blank">
                <img src={oisix} alt="Oisix" />
              </a>
              <a href="https://www.dely.jp/" target="_blank">
                <img src={dely} alt="dely" />
              </a>
              <a href="https://about.mercari.com/about/" target="_blank">
                <img src={mercari} alt="mercari" />
              </a>
              <a href="https://jp.merpay.com/about/" target="_blank">
                <img src={merpay} alt="merpay" />
              </a>
              <a href="https://www.bizreach.co.jp/" target="_blank">
                <img src={bizreach} alt="BizReach" />
              </a>
            </div>
            <div className="silver">
              <h3>
                <span>SILVER</span>
              </h3>
              <a href="http://elastic.co" target="_blank">
                <img src={elastic} alt="Elastic" />
              </a>
              <a href="https://crowdworks.co.jp/" target="_blank">
                <img src={crowdworks} alt="CrowdWorks" />
              </a>
              <a href="https://www.optim.co.jp/" target="_blank">
                <img src={optim} alt="OPTiM" />
              </a>
              <a href="https://speee.jp/" target="_blank">
                <img src={speee} alt="Speee" />
              </a>
            </div>
            <div className="bronze">
              <h3>
                <span>BRONZE</span>
              </h3>
              <a href="https://about.stores.jp/" target="_blank">
                <img src={stores} alt="STORES.jp" />
              </a>
              <a href="https://hatenacorp.jp/" target="_blank">
                <img src={hatena} alt="Hatena" />
              </a>
              <a href="http://www.nikkei.co.jp/nikkeiinfo/" target="_blank">
                <img src={nikkei} alt="NIKKEI" />
              </a>
              <a href="https://www.sumzap.co.jp/" target="_blank">
                <img src={sumzap} alt="Sumzap" />
              </a>
              <a href="https://www.dip-net.co.jp" target="_blank">
                <img src={dip} alt="dip" />
              </a>
              <a href="http://corporate.bengo4.com" target="_blank">
                <img src={bengo4} alt="弁護士ドットコム" />
              </a>
              <a href="https://www.quipper.com/jp/" target="_blank">
                <img src={quipper} alt="Quipper" />
              </a>
            </div>
            <div className="other">
              <h3>
                <span>OTHER</span>
              </h3>
              <a href="https://www.hennge.com" target="_blank">
                <img src={hennge} alt="HENNGE" />
                <p>
                  ドリンク
                  <br />
                  スポンサー
                </p>
              </a>
              <a
                href="https://engineer.recruit-lifestyle.co.jp/recruiting/"
                target="_blank"
              >
                <img src={recruitlifestyle} alt="リクルートライフスタイル" />
                <p>
                  おやつ
                  <br />
                  スポンサー
                </p>
              </a>
              <a href="https://nulab.com/" target="_blank">
                <img src={nulab} alt="nulab" />
                <p>
                  ツール
                  <br />
                  スポンサー
                </p>
              </a>
              <a href="https://sakura.yoga/" target="_blank">
                <img src={sakurayoga} alt="Sakura Yoga" />
                <p>
                  ヨガ
                  <br />
                  スポンサー
                </p>
              </a>
            </div>
            <div className="personal">
              <h3>
                <span>PERSONAL</span>
              </h3>
              <a href="https://twitter.com/netmarkjp/" target="_blank">
                <div>
                  <img src={netmarkjp} alt="netmarkjp" />
                  <p>netmarkjp</p>
                </div>
              </a>
              <a href="https://twitter.com/Kazumatcha/" target="_blank">
                <div>
                  <img src={Kazu} alt="Kazu" />
                  <p>Kazu</p>
                </div>
              </a>
              <a href="https://twitter.com/k12u/" target="_blank">
                <div>
                  <img src={k12u} alt="k12u" />
                  <p>k12u</p>
                </div>
              </a>
              <a href="https://twitter.com/lunaphilia/" target="_blank">
                <div>
                  <img src={lunaphilia} alt="Kazuya Fujiwara" />
                  <p>Kazuya Fujiwara</p>
                </div>
              </a>
              <a href="https://twitter.com/naofumi0628" target="_blank">
                <div>
                  <img src={naofumi0628} alt="Naofumi Yamada@PKSHA" />
                  <p>Naofumi Yamada&#8203;@PKSHA</p>
                </div>
              </a>
              <div>
                <img src={ohr486} alt="ohr486" />
                <p>ohr486</p>
              </div>
              <a href="https://qiita.com/hmatsu47" target="_blank">
                <div>
                  <img src={hmatsu47} alt="hmatsu47(松久裕保)" />
                  <p>hmatsu47&#8203;(松久裕保)</p>
                </div>
              </a>
              <a href="https://twitter.com/tigerroll54s" target="_blank">
                <div>
                  <img src={tigerroll} alt="tigerroll" />
                  <p>tigerroll</p>
                </div>
              </a>
              <a href="https://twitter.com/tyabe/" target="_blank">
                <div>
                  <img src={tyabe} alt="Takeshi Yabe(@tyabe)" />
                  <p>Takeshi Yabe&#8203;(@tyabe)</p>
                </div>
              </a>
              <a href="https://twitter.com/tmknom/" target="_blank">
                <div>
                  <img src={tmknom} alt="実践Terraform著者" />
                  <p>実践Terraform著者</p>
                </div>
              </a>
              <a href="https://twitter.com/nntsugu/" target="_blank">
                <div>
                  <img src={nntsugu} alt="nntsugu" />
                  <p>nntsugu</p>
                </div>
              </a>
              <a href="https://d.nekoruri.jp/ " target="_blank">
                <div>
                  <img src={nekoruri} alt="NAKAYAMA MASAHIRO" />
                  <p>NAKAYAMA MASAHIRO</p>
                </div>
              </a>
              <a href="https://twitter.com/_zoo/" target="_blank">
                <div>
                  <img src={mass} alt="mass" />
                  <p>mass</p>
                </div>
              </a>
              <a href="https://twitter.com/yoshikaw/" target="_blank">
                <div>
                  <img src={yoshikaw} alt="Kazuhiro YOSHIKAWA" />
                  <p>Kazuhiro YOSHIKAWA</p>
                </div>
              </a>
              <a href="https://sky-joker.tech/" target="_blank">
                <div>
                  <img src={sky_joker} alt="sky_joker" />
                  <p>sky_joker</p>
                </div>
              </a>
              <a href="https://qiita.com/dododo8m" target="_blank">
                <div>
                  <img src={dododo8m} alt="dododo8m" />
                  <p>dododo8m</p>
                </div>
              </a>
              <a href="https://twitter.com/mtsuka/" target="_blank">
                <div>
                  <img src={mtsuka} alt="mtsuka" />
                  <p>mtsuka</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default Sponsor
